import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Modal de avaliação descritiva da nota, extraído de DesempenhoEscolarComponent.
 * UI pura — o cálculo de `readonly` (baseado em $$editavelAnual/$$editavel/$$isSaving
 * da nota) e o salvamento continuam no componente pai.
 */
@Component({
  selector: 'app-avaliacao-descritiva-modal',
  templateUrl: './avaliacao-descritiva-modal.component.html'
})
export class AvaliacaoDescritivaModalComponent {
  @Input() aberto = false;
  @Input() titulo = '';
  @Input() nomeAluno = '';
  @Input() readonly = false;
  @Input() texto = '';

  @Output() textoChange = new EventEmitter<string>();
  @Output() salvar = new EventEmitter<void>();
  @Output() fechar = new EventEmitter<void>();

  onTextoChange(valor: string): void {
    this.texto = valor;
    this.textoChange.emit(valor);
  }
}
